import type { RadioBooleanFilterValueType } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioBooleanFilter/GenericRadioBooleanType';
import { RadioBooleanFilterOperation } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioBooleanFilter/GenericRadioBooleanType';
import type { IntermediateFormat } from '../../../../domains/global-filters/model/IntermediateFormat';
import type {
  QueryFormatFilter,
  QueryKeyEnum,
} from '../../../../domains/global-filters/model/QueryFormat';
import { QueryMapOperandEnum } from '../../../../domains/global-filters/model/QueryFormat';

const shouldNotHappen = (never: never): void => {
  throw new Error(`Unknown type: ${never}`);
};

export function fromUiToQueryFormat(
  uiValue: RadioBooleanFilterValueType,
  queryKey: QueryKeyEnum,
): QueryFormatFilter {
  if (!uiValue) {
    return {};
  }
  switch (uiValue.operation) {
    case RadioBooleanFilterOperation.IS_TRUE: {
      return {
        [QueryMapOperandEnum.EQUAL]: { [queryKey]: true },
      };
    }
    case RadioBooleanFilterOperation.IS_FALSE: {
      return {
        [QueryMapOperandEnum.NOT]: {
          [QueryMapOperandEnum.EQUAL]: { [queryKey]: true },
        },
      };
    }
    case RadioBooleanFilterOperation.IS_UNKNOWN: {
      return {
        [QueryMapOperandEnum.UNKNOWN]: {
          [queryKey]: true,
        },
      };
    }
    case RadioBooleanFilterOperation.HAS_ANY_VALUE: {
      return {
        [QueryMapOperandEnum.NOT]: {
          [QueryMapOperandEnum.UNKNOWN]: {
            [queryKey]: true,
          },
        },
      };
    }
    default: {
      shouldNotHappen(uiValue.operation);
    }
  }

  return {};
}

export function fromIntermediateToUiFormat(
  intermediateValue: IntermediateFormat,
): RadioBooleanFilterValueType {
  const { operation, negate } = intermediateValue;
  switch (operation[0]) {
    case QueryMapOperandEnum.DAYS_AGO:
    case QueryMapOperandEnum.GREATER_THAN:
    case QueryMapOperandEnum.LESS_THAN:
    case QueryMapOperandEnum.RANGE_IN:
    case QueryMapOperandEnum.NOT:
    case QueryMapOperandEnum.ENDS_WITH:
    case QueryMapOperandEnum.STARTS_WITH:
    case QueryMapOperandEnum.REGEX:
    case QueryMapOperandEnum.SIMPLE_MATCH:
    case QueryMapOperandEnum.CONTAINS:
    case QueryMapOperandEnum.DROPOFF: {
      // We ignore
      break;
    }
    case QueryMapOperandEnum.UNKNOWN: {
      return negate === true
        ? {
            operation: RadioBooleanFilterOperation.HAS_ANY_VALUE,
          }
        : {
            operation: RadioBooleanFilterOperation.IS_UNKNOWN,
          };
    }
    case QueryMapOperandEnum.EQUAL: {
      return negate === true
        ? {
            operation: RadioBooleanFilterOperation.IS_FALSE,
          }
        : {
            operation: RadioBooleanFilterOperation.IS_TRUE,
          };
    }
    default: {
      shouldNotHappen(operation[0]);
    }
  }
  throw new Error(`Operation not implemented: ${operation}`);
}
